import { render } from "./leadsStatusLegendModal.vue?vue&type=template&id=482b7db9&ts=true"
import script from "./leadsStatusLegendModal.ts?vue&type=script&lang=ts"
export * from "./leadsStatusLegendModal.ts?vue&type=script&lang=ts"

import "./leadsStatusLegendModal.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__